import { Component } from '@angular/core';

@Component({
  selector: 'wsb-studio',
  templateUrl: './studio.component.html',
  styleUrls: ['./studio.component.scss'],
  standalone: false
})
export class StudioComponent {
  constructor() {}
}
